<template>
  <div class="px-2 py-2 xl:py-4 lg:py-6 max-w-xl mx-auto min-h-50">
    <div class="mx-auto mb-4 overflow-hidden">
      <div class="flex flex-wrap mt-6 mx-1">
        <div class="signin w-full flex justify-center sm:justify-end min-h-xl">
          <div class="w-full pt-3">
            <div class="dialog__header px-2 sm:px-12">
              <img src="@/assets/icon/check_circle-3.png" class="mx-auto">
              <h5 class="px-8 text-NotoSansBold text-center">
                <span class="inline-block align-top leading-loose textColorRed text-xl md:text-2xl">Successfully verified!</span>
              </h5>
            </div>
            <div class="dialog__body">
              <div class="bg-white rounded px-2 sm:px-12 py-6">
                <div class="mb-6 textColorBlack text-center">
                  <h5 class="text-NotoSansRegular">信箱驗證已通過！</h5>
                </div>
                <div class="flex items-center px-0 justify-center md:justify-end">
                  <router-link :to="{ name: 'index'}" class="text-center text-sm button-red text-white py-2 px-6 rounded outline-none focus:outline-none w-full md:w-auto text-NotoSansRegular mb-4 sm:mb-0 cursor-pointer"
                    type="button">
                    開始購物
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Regex from '@/components/modules/regex'
import sweetAlert from '@/components/modules/sweetAlert'
export default {
  name: 'emailVerification',
  data () {
    return {
      validate: false
    }
  },
  components: {
  },
  mixins: [
    Regex,
    sweetAlert
  ],
  computed: {
  },
  mounted () {
    this.getToken()
  },
  updated () {
  },
  methods: {
    getToken () {
      let self = this
      if (self.$route.params.email && self.$route.params.token && self.$route.params.action) {
        let path = `/subscribe/epaper/${self.$route.params.email}/validate/${self.$route.params.token}/${self.$route.params.action}`
        axios.post(path)
          .then((response) => {
            self.validate = true
          })
          .catch(() => {
            self.validate = false
            self.alertPop('warning', '此email已訂閱或變更代碼逾時!!')
            // self.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '此email已訂閱或變更代碼逾時!!', type: 'alert' })
            self.$router.push({ name: 'index' })
          })
      } else {
        self.$router.push({ name: 'index' })
        self.alertPop('warning', '發生錯誤或變更代碼逾時')
        // self.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '發生錯誤或變更代碼逾時', type: 'alert' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .box1 img{
  -webkit-box-reflect:below 0 -webkit-linear-gradient(top,rgba(250,250,250,0),rgba(250,250,250,.0) 30%,rgba(250,250,250,.3));
  }
  .dialog__body {
    .fb-btn {
      background-color: #3b5998;
      &:hover {
        background-color: #29487d;
      }
    }
    #my-signin2{
      .abcRioButtonContentWrapper {
        display: flex;
        justify-content: center;
      }
      width: 100% !important;
      .abcRioButton, .abcRioButtonBlue {
        background-color: white;
        width: 100% !important;
        height: 40px !important;
        border-radius: 0.25rem !important;
        height: auto;
        &:hover {
          box-shadow: 0 2px 4px 0 rgba(0,0,0,.25);
        }
        .abcRioButtonContents {
        font-weight: 700 !important;
        font-size: 1rem !important;
        color: black;
        }
      }
    }
    .social-login-option:before, .social-login-option:after {
        background-color: #dde1e4;
        content: "";
        display: inline-block;
        height: 1px;
        position: relative;
        vertical-align: middle;
        width: 45%;
    }
    .social-login-option:before {
      right: .5rem;
      // margin-left: -50%;
    }
    .social-login-option:after {
      left: .5em;
      // margin-right: -50%;
    }
  }

  .input-text {
    background-color: white;
    border: 1px solid #cccccc;
    padding: 8px 4px;
    position: relative;
    width: 100%;
    z-index: 3;
  }

  .label-helper {
    position: absolute;
    opacity: 0;
    transition: .2s bottom, .2s opacity;
    bottom: 0;
    left: 0;
    z-index: 1;
  }

  .input-text:focus + .label-helper, .input-text:invalid + .label-helper {
    bottom: 95%;
    line-height: 1;
    opacity: 1;
    }

  .input-text:not(:placeholder-shown) ~ label,
  .input-text:-webkit-autofill ~ label {
    bottom: 95%;
    line-height: 1;
    opacity: 1;
  }
</style>
